import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-offer-confirmation',
  templateUrl: './offer-confirmation.component.html',
  styleUrls: ['./offer-confirmation.component.scss']
})
export class OfferConfirmationComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<OfferConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _router: Router) {
     
     }
    

  ngOnInit(): void {
  }
  
  closeDialog() {
    this.dialogRef.close();
    const assignedLoadId = this.data?.id || this.data?.loadId || this.data?.loadid;
    this._router.navigate(['owner-operator/shipments/assigned-loads/details', assignedLoadId], {
      replaceUrl: true,
      state: { assignedBackRoute: this.getAssignedBackRoute(this._router.url) }
    });
  }

  private getAssignedBackRoute(currentUrl: string): string {
    if (!currentUrl) {
      return '/owner-operator/assigned-loads';
    }

    if (currentUrl.includes('/owner-operator/bids/invited-loads')) {
      return '/owner-operator/bids/invited-loads';
    }

    if (currentUrl.includes('/owner-operator/shipments/invited-loads')) {
      return '/owner-operator/shipments/invited-loads';
    }

    if (currentUrl.includes('/owner-operator/shipments/tendered-loads')) {
      return '/owner-operator/shipments/tendered-loads';
    }

    if (currentUrl.includes('/owner-operator/shipments/open-loads')) {
      return '/owner-operator/open-loads';
    }
    
    if (currentUrl.includes('/owner-operator/open-loads')) {
      return '/owner-operator/open-loads';
    }

    return '/owner-operator/assigned-loads';
  }

}
